import React, { useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import moment from 'moment'
import InputWrapper from './InputWrapper'
import InputIcon from './InputIcon'

function DateInput({
  value,
  onChange,
  error = false,
  isValid,
  placeholder,
  id,
  icon,
  rules,
  rawValue,
  ...rest
}) {
  const [open, setOpen] = useState(false)
  const format = rest.type === `month` ? `MMMM` : `DD/MM/YYYY`

  function handleClick() {
    if (!rest.disabled) {
      setOpen(!open)
    }
  }

  function handleNextValue(nextValue) {
    const value = moment(nextValue).format(format)
    onChange({ value, name: id, rawValue: nextValue })
    setOpen(false)
  }

  const props = {
    open,
    format,
    error,
    value: value ? (typeof rawValue === `string` ? new Date(rawValue) : rawValue) : value,
    onChange: handleNextValue,
    onClick: handleClick,
    views: rest.type === `month` ? [`month`] : [`year`, `date`, `month`],
    disableToolbar: true,
    variant: `inline`,
    keyboardIcon: icon ? <InputIcon icon={icon} button /> : null,
    disabled: rest.disabled,
    KeyboardButtonProps: {
      'aria-label': `change date`,
    },
    inputProps: {
      autoFocus: false,
    },
  }

  // eslint-disable-next-line
  return (
    <InputWrapper isRequired={rules?.required} error={error} {...rest}>
      <KeyboardDatePicker {...props} />
    </InputWrapper>
  )
}

export default DateInput
